var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxMultiple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "checkboxMultiple_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.833 11.7c0-.458.375-.833.834-.833s.833.375.833.833v3.284c0 1.375-1.125 2.5-2.5 2.5H5a2.507 2.507 0 0 1-2.5-2.5v-10c0-1.375 1.125-2.5 2.5-2.5h8.75c.458 0 .833.375.833.833a.836.836 0 0 1-.833.833H5a.836.836 0 0 0-.833.834v10c0 .458.375.833.833.833h10a.836.836 0 0 0 .833-.833z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.08 5.362a.833.833 0 0 1 .004 1.179l-6.493 6.546a.834.834 0 0 1-1.18.002L5.417 9.51a.833.833 0 1 1 1.178-1.178l3.403 2.986 5.903-5.953a.833.833 0 0 1 1.179-.004",
  clipRule: "evenodd"
})));
export default SvgCheckboxMultiple;